import { Injectable } from '@angular/core';
import { TranslateCompiler } from '@ngx-translate/core';
import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';
import { isString, isObject } from 'lodash';

@Injectable()
export class ConditionalMessageFormatCompiler extends TranslateCompiler {
  private messageFormat: TranslateMessageFormatCompiler = new TranslateMessageFormatCompiler();
  private readonly icuRegex = /{.*,\s*(plural|select)\s*,/;

  public compile(value: string, lang: string): string | Function {
    if (this.icuRegex.test(value)) {
      return this.messageFormat.compile(value, lang);
    }
    return value;
  }

  public compileTranslations(translations: any, lang: string): any {
    const compile = (translation: any) => {
      Object.keys(translation).forEach(key => {
        const value = translation[key];

        if (isObject(value)) return compile(value);

        if (isString(value) && this.icuRegex.test(value)) {
          translation[key] = this.messageFormat.compile(value, lang);
        }
      });
    };

    compile(translations);
    return translations;
  }
}
